import { render, staticRenderFns } from "./Employees1.vue?vue&type=template&id=28c2d993&scoped=true"
import script from "./Employees1.vue?vue&type=script&lang=ts"
export * from "./Employees1.vue?vue&type=script&lang=ts"
import style0 from "./Employees1.vue?vue&type=style&index=0&id=28c2d993&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c2d993",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VProgressCircular,VRow})
